import { SERVICE_AREAS } from "@/data/siteData";

const items = [...SERVICE_AREAS.slice(0, 4), "NABCEP Licensed", "BBB Accredited", "Certified Service Partner"];

export const ServiceAreaStrip = () => (
  <div data-testid="service-area-strip" className="overflow-hidden border-y border-border/60 bg-secondary py-4">
    <div className="marquee flex w-max gap-12 font-display text-sm tracking-wide text-primary">
      {[...items, ...items].map((t, i) => (
        <span key={i} className="flex items-center gap-12">
          {t}
          <span className="h-1 w-1 rounded-full bg-accent" />
        </span>
      ))}
    </div>
  </div>
);
